import crud from '@/crud/form/form'
import resources from '../../resources'
import validations from './validations'
import mounted from './mounted'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,
  validations,
  mounted,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/form/resources/index.js